import { defineWidget } from "@easysaas/widget-core";
import tokens from "@easysaas/ui/tokens.css?inline";
import widgetStyles from "./styles.css?inline";
import Widget from "./Widget";
import { attrs } from "../widget.config";

defineWidget({
  name: "payment-comparison",
  component: Widget,
  attrs,
  styles: tokens + widgetStyles,
});
